<template>
    <v-card class="pa-3 ma-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista Protocolos</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="openFormProtocolo(null)"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-book-plus-outline</v-icon>
                </v-btn>
            </template>
            <span>Nuevo Protocolo</span>
        </v-tooltip>

        <v-card-text>
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field
                        prepend-icon="mdi-account-search"
                        v-model="search"
                        label="Buscar"
                    ></v-text-field>
                </v-col>
            </v-row>
            <template>
                <!-- <v-row align-md="end" justify="end" class="mr-4 mb-2">
                <v-btn-toggle v-model="toggle_exclusive" rounded>
                    <v-btn
                        ><v-icon>mdi-filter-plus-outline</v-icon
                        ><strong>
                            <pre style="color: green"> Activos</pre>
                        </strong></v-btn
                    >
                    <v-btn
                        ><v-icon>mdi-filter-minus-outline</v-icon
                        ><strong>
                            <pre style="color: red"> Inactivos</pre>
                        </strong></v-btn
                    >
                    <v-btn
                        ><v-icon>mdi-filter</v-icon
                        ><strong>
                            <pre style="color: blue"> Todos</pre>
                        </strong></v-btn
                    >
                </v-btn-toggle>
            </v-row> -->
                <v-row justify="center">
                    <v-expansion-panels accordion>
                        <v-expansion-panel
                            v-for="(producto, i) in protocolos"
                            :key="i"
                        >
                            <v-expansion-panel-header>{{
                                producto.nombre
                            }}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-data-table
                                    dense
                                    :headers="computedHeaders"
                                    :items="producto.items"
                                    :search="search"
                                    disable-pagination
                                    hide-default-footer
                                    :items-per-page="15"
                                    item-key="id"
                                    class="elevation-1"
                                    :sort-by="['nombre']"
                                    :sort-desc="[false]"
                                >
                                    <template
                                        v-slot:item.descripcion="{ item }"
                                    >
                                        <div
                                            class="description-cell"
                                            v-html="item.descripcion"
                                        ></div>
                                    </template>

                                    <!-- Solo se muestran los botones de editar y borrar si el usuario es administrador, el id es 1287 (María Jesús García) o el id es 277 -->
                                    <template v-slot:item.action="{ item }">
                                        <v-icon
                                            @click="openFormProtocolo(item)"
                                            small
                                            class="mr-2"
                                            color="#1d2735"
                                            style="font-size: 25px"
                                            title="EDITAR"
                                            >mdi-pencil-outline</v-icon
                                        >
                                        <v-icon
                                            @click="openModal(item)"
                                            small
                                            class="mr-2"
                                            color="red"
                                            style="font-size: 25px"
                                            title="BORRAR"
                                            >mdi-trash-can</v-icon
                                        >
                                        <!-- <v-icon
                                        v-if="item.activo == 1"
                                        @click="openModalEstado(item)"
                                        small
                                        class="mr-2"
                                        color="red"
                                        style="font-size: 25px"
                                        title="Desactivar"
                                        >mdi-cancel</v-icon
                                    >
                                    <v-icon
                                        v-else
                                        @click="openModalEstado(item)"
                                        small
                                        class="mr-2"
                                        color="green"
                                        style="font-size: 25px"
                                        title="Activar"
                                        >mdi-check</v-icon
                                    > -->
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
            </template>
        </v-card-text>

        <FormProtocolo
            v-model="isFormProtocoloVisible"
            :item="selectedItem"
            @refresh="getProtocolos"
        />

        <DeleteDialog
            v-model="dialog"
            :id="selectedItem.id"
            @delete="deleteProtocolo"
        />

        <!-- Por ahora en desuso -->
        <!-- <v-dialog v-model="dialog_estado" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>
                        Esta seguro que desea cambiar el estado del producto?
                    </h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog_estado = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="ChangeProductoState()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog> -->
    </v-card>
</template>
<script>
import DeleteDialog from "../../../components/general/DeleteDialog.vue";
import FormProtocolo from "./FormProtocolo.vue";
import { mapGetters } from 'vuex';

export default {
    components: {
        DeleteDialog,
        FormProtocolo,
    },
    data() {
        return {
            search: "",
            headers: [
                { text: "Título", value: "titulo", sortable: false },
                { text: "Descripción", value: "descripcion", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            protocolos: [],
            selectedItem: {
                id: null,
                titulo: null,
                descripcion: null,
                id_producto_modulo: null,
            },
            dialog: false,
            dialog_estado: false,
            toggle_exclusive: 0,
            isFormProtocoloVisible: false,
        };
    },
    created() {
        this.getProtocolos(this.estado);
    },
    watch: {
        toggle_exclusive(n) {
            /*if (this.toggle_exclusive == 0) {
                this.getActiveClientes();
            } else if (this.toggle_exclusive == 1) {
                this.getInactiveClientes();
            } else if (this.toggle_exclusive == 2) {
                this.getAllClientes();
            } else {
                this.usuarios = [];
            }*/

            this.getProtocolos(this.estado);
        },
        search: function (n) {
            this.getProtocolos();
        },
    },
    methods: {
        getProtocolos(estado) {
            const self = this;
            axios
                .get(`api/get-protocolos`, {
                    params: {
                        search: this.search,
                    },
                })
                .then((res) => {
                    self.protocolos = res.data;
                })
                .catch((err) => {
                    self.$toast.error(err.response.data.message);
                });
        },
        openModal(item) {
            this.selectedItem = item;
            this.dialog = true;
        },
        openFormProtocolo(item) {
            if (item != null) {
                this.selectedItem = item;
            } else {
                this.selectedItem = {
                    id: null,
                    titulo: null,
                    descripcion: null,
                    id_producto_modulo: null,
                };
            }

            this.isFormProtocoloVisible = true;
        },
        openModalEstado(item) {
            this.selectedItem = item;
            this.dialog_estado = true;
        },
        ChangeProductoState() {
            const body = JSON.parse(JSON.stringify(this.selectedItem));
            body.activo = body.activo == 1 ? 0 : 1;
            const self = this;
            axios.post("api/save-producto", body).then(function (response) {
                self.$toast.sucs("Guardado con éxito");
                self.dialog_estado = false;
                self.getProtocolos(self.estado);
            });
        },
        deleteProtocolo() {
            axios
                .delete(`api/delete-protocolo/${this.selectedItem.id}`)
                .then((res) => {
                    this.$toast.sucs(res.data.message);
                    this.dialog = false;
                    this.getProtocolos(this.estado);
                })
                .catch((err) => {
                    this.$toast.error(err.response.data.message);
                });
        },
    },
    computed: {
        ...mapGetters({
            userRole: 'auth/userRole'
        }),
        estado: function () {
            const n = this.toggle_exclusive;
            const estado = n == 0 ? 1 : n == 1 ? 0 : null;
            return estado;
        },
        role: function () {
            return this.userRole;
        },
        user_id: function () {
            return localStorage.getItem("user_id");
        },
        computedHeaders: function () {
            return this.role == 1 || this.user_id == 1287 || this.user_id == 277
                ? this.headers
                : this.headers.filter((header) => header.value !== "action");
        },
    },
};
</script>

<style>
.description-cell {
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Estilos para el contenido HTML renderizado */
.description-cell :deep(p) {
    margin: 0;
}
.description-cell :deep(ul),
.description-cell :deep(ol) {
    margin: 0;
    padding-left: 20px;
}
</style>
